import * as React from "react";
import {IIncome} from "../../../../config/income";
import {FreeTextField} from "../../../Components/Form/FreeTextField";
import {MoneyField} from "../../../Components/Form/MoneyField";
import { useForm } from "../../../../hooks/use_form_v2";
import { Form } from "../../../Components/Form/Form/Form";
import { IIncomeForm, IIncomeRequest, IncomeForm as IncomeFormHandler } from "../../../../forms/settings_income_form";

export interface IIncomeState {
    name: string;
    amount: string;
}

interface IIncomeFormProps {
    income?: IIncome;
    onSubmit(data: IIncomeRequest): Promise<any>;
}

export const IncomeForm = ({income, onSubmit}: IIncomeFormProps) => {
    const form = useForm<IIncomeForm, IIncomeRequest>(new IncomeFormHandler(income));
    const { register, toRequest } = form;

    const handleSubmit = (values: IIncomeForm): Promise<any> => {
        return onSubmit(toRequest(values));
    };

    return (
        <Form form={form} onSubmit={handleSubmit}>
            <Form.Field type={FreeTextField} {...register('name')} />
            <Form.Field type={MoneyField} {...register('amount')} />
        </Form>
    );
};
